/* eventTracking.js */
var trackEvent = function(eventCategory, eventAction, eventLabel, value, nonInteraction) {

    var tracking = {
        _active: false,
        _tools: [],
        params: {
            category: eventCategory,
            action: eventAction,
            label: eventLabel,
            value: (value) ? value : 1,
            nonInteraction: (nonInteraction) ? nonInteraction : false
        }
    };

    if (getCookie('cookieConsented-analysis') == '1') {

        tracking._active = true;
        gtag('event', tracking.params.action, {
            'event_category': tracking.params.category,
            'event_label': tracking.params.label,
            'value': tracking.params.value,
            'non_interaction': tracking.params.nonInteraction
        });
        tracking._tools.push('GA');

    }

    if ($('#matomoTracking').length) {

        tracking._active = true;
        _paq.push(['trackEvent', tracking.params.category, tracking.params.action, tracking.params.label, tracking.params.value]);
        tracking._tools.push('Matomo');

    }

    console.log('eventTracking', tracking);

};